"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var upsellsSlider = /** @class */ (function () {
    function upsellsSlider() {
        this.$owl = $('.upsell-product-info__carousel');
        this.initCarousel();
    }
    upsellsSlider.prototype.initCarousel = function () {
        var $src = '/app/themes/tedee/assets/images';
        this.$owl.owlCarousel({
            items: 2,
            slideSpeed: 2000,
            nav: true,
            autoplay: true,
            dots: true,
            loop: false,
            navText: [
                '<img src=' + $src + '/arrow-previous_org.svg class = "upsell-product-info__prev" alt="prev arrow">',
                '<img src=' + $src + '/arrow-next_org.svg class = "upsell-product-info__next" alt="next arrow">'
            ],
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 2,
                },
                1024: {
                    items: 3,
                    nav: false
                }
            }
        });
    };
    return upsellsSlider;
}());
exports.default = upsellsSlider;
